export type UserRole = 'Team' | 'Membre' | 'Hôte' | 'Visiteur' | null

export interface Permission {
  canViewMembers: boolean
  canEditMembers: boolean
  canDeleteMembers: boolean
  canCreateEvents: boolean
  canEditEvents: boolean
  canDeleteEvents: boolean
  canViewAnalytics: boolean
  canManageVenues: boolean
  canSendMessages: boolean
  canBroadcastMessages: boolean
  canViewReports: boolean
  canExportData: boolean
  canManageRoles: boolean
  canAccessAdmin: boolean
}

export const ROLE_PERMISSIONS: Record<string, Permission> = {
  'Team': {
    canViewMembers: true,
    canEditMembers: true,
    canDeleteMembers: true,
    canCreateEvents: true,
    canEditEvents: true,
    canDeleteEvents: true,
    canViewAnalytics: true,
    canManageVenues: true,
    canSendMessages: true,
    canBroadcastMessages: true,
    canViewReports: true,
    canExportData: true,
    canManageRoles: true,
    canAccessAdmin: true
  },
  'Hôte': {
    canViewMembers: true,
    canEditMembers: false,
    canDeleteMembers: false,
    canCreateEvents: true,
    canEditEvents: true,
    canDeleteEvents: false,
    canViewAnalytics: true,
    canManageVenues: true,
    canSendMessages: true,
    canBroadcastMessages: false,
    canViewReports: true,
    canExportData: false,
    canManageRoles: false,
    canAccessAdmin: true
  },
  'Membre': {
    canViewMembers: true,
    canEditMembers: false,
    canDeleteMembers: false,
    canCreateEvents: false,
    canEditEvents: false,
    canDeleteEvents: false,
    canViewAnalytics: false,
    canManageVenues: false,
    canSendMessages: true,
    canBroadcastMessages: false,
    canViewReports: false,
    canExportData: false,
    canManageRoles: false,
    canAccessAdmin: false
  },
  'Visiteur': {
    canViewMembers: false,
    canEditMembers: false,
    canDeleteMembers: false,
    canCreateEvents: false,
    canEditEvents: false,
    canDeleteEvents: false,
    canViewAnalytics: false,
    canManageVenues: false,
    canSendMessages: false,
    canBroadcastMessages: false,
    canViewReports: false,
    canExportData: false,
    canManageRoles: false,
    canAccessAdmin: false
  }
}

export function getUserPermissions(role: UserRole): Permission {
  const roleKey = role || 'Visiteur'
  return ROLE_PERMISSIONS[roleKey] || ROLE_PERMISSIONS['Visiteur']
}

export function hasPermission(role: UserRole, permission: keyof Permission): boolean {
  const permissions = getUserPermissions(role)
  return permissions[permission]
}

export function canAccessRoute(role: UserRole, routeName: string): boolean {
  const permissions = getUserPermissions(role)
  
  const routePermissions: Record<string, keyof Permission> = {
    'admin': 'canAccessAdmin',
    'members': 'canViewMembers', 
    'events': 'canViewMembers', // Events are visible to members
    'venues': 'canManageVenues',
    'messages': 'canSendMessages',
    'reports': 'canViewReports'
  }
  
  const requiredPermission = routePermissions[routeName]
  return requiredPermission ? permissions[requiredPermission] : true
}